<template>
  <span
    :class="{
      bold: formats.includes('bold'),
      italic: formats.includes('italic'),
      heading: formats.includes('heading'),
      deleted: formats.includes('deleted'),
    }"
  >
    <template v-if="data.format === 'url'">
      <a :href="data.href"><slot/></a>
    </template>
    <template v-else-if="data.format === 'internal-url'">
      <router-link :to="{ name: data.name }"><slot/></router-link>
    </template>
    <template v-else>
      <slot/>
    </template>
  </span>
</template>
<script>

export default {
  props: ['data'],
  computed: {
    formats() {
      return (typeof this.data.format === 'string' ? [this.data.format] : this.data.format) || [];
    },
  }
}

</script>

<style scoped lang="scss">

span {
  &.bold {
    font-weight: bold;
  }

  &.italic {
    font-style: italic;
  }

  &.heading {
    font-size: 120%;
    text-transform: uppercase;
  }

  &.deleted {
    text-decoration: line-through;
    opacity: 0.5;
  }
}

</style>
